import { HelpInquiryRouteParams } from './config';
import HelpService from './service';
import {
  CancelHelpInquiryStatusResponse,
  SubmitHelpPayload,
  SubmitHelpResponse,
  UpdateHelpInquiryStatusParams,
  UpdateHelpInquiryStatusResponse,
} from './types';

export class HelpMutations {
  public static readonly submitHelp = async (payload: SubmitHelpPayload): Promise<SubmitHelpResponse> => {
    const response = await HelpService.submitHelp(payload);

    return response;
  };

  public static readonly updateHelpInquiryStatus = async (
    payload: UpdateHelpInquiryStatusParams
  ): Promise<UpdateHelpInquiryStatusResponse> => {
    const response = await HelpService.updateHelpInquiryStatus(payload);

    return response;
  };

  public static readonly cancelHelpInquiry = async (
    payload: HelpInquiryRouteParams
  ): Promise<CancelHelpInquiryStatusResponse> => {
    const response = await HelpService.cancelHelpInquiry(payload);

    return response;
  };
}
